import createIcon from '../../createIcon';

/**
 * @component @name OtherHouses
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTIgM0wxIDExLjRMMi4yMSAxMi45OUw0IDExLjYyVjIxSDIwVjExLjYyTDIxLjc5IDEyLjk4TDIzIDExLjRMMTIgM1pNOCAxNUM3LjQ1IDE1IDcgMTQuNTUgNyAxNEM3IDEzLjQ1IDcuNDUgMTMgOCAxM0M4LjU1IDEzIDkgMTMuNDUgOSAxNEM5IDE0LjU1IDguNTUgMTUgOCAxNVpNMTIgMTVDMTEuNDUgMTUgMTEgMTQuNTUgMTEgMTRDMTEgMTMuNDUgMTEuNDUgMTMgMTIgMTNDMTIuNTUgMTMgMTMgMTMuNDUgMTMgMTRDMTMgMTQuNTUgMTIuNTUgMTUgMTIgMTVaTTE2IDE1QzE1LjQ1IDE1IDE1IDE0LjU1IDE1IDE0QzE1IDEzLjQ1IDE1LjQ1IDEzIDE2IDEzQzE2LjU1IDEzIDE3IDEzLjQ1IDE3IDE0QzE3IDE0LjU1IDE2LjU1IDE1IDE2IDE1WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const OtherHouses = createIcon('OtherHouses', [
  [
    'path',
    {
      d: 'M12 3L1 11.4L2.21 12.99L4 11.62V21H20V11.62L21.79 12.98L23 11.4L12 3ZM8 15C7.45 15 7 14.55 7 14C7 13.45 7.45 13 8 13C8.55 13 9 13.45 9 14C9 14.55 8.55 15 8 15ZM12 15C11.45 15 11 14.55 11 14C11 13.45 11.45 13 12 13C12.55 13 13 13.45 13 14C13 14.55 12.55 15 12 15ZM16 15C15.45 15 15 14.55 15 14C15 13.45 15.45 13 16 13C16.55 13 17 13.45 17 14C17 14.55 16.55 15 16 15Z',
      key: '1sldtq',
    },
  ],
]);

export default OtherHouses;
